var _g, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSolutionMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 272,
    height: 152,
    viewBox: "0 0 272 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5930_3158)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.927734,
    y: 0.400024,
    width: 270.144,
    height: 151.2,
    rx: 8.4672,
    fill: "url(#paint0_linear_5930_3158)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.927734,
    y: 0.400024,
    width: 270.144,
    height: 151.2,
    rx: 8.4672,
    fill: "url(#paint1_linear_5930_3158)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -35.7856,
    y: 217.023,
    width: 301.896,
    height: 301.896,
    rx: 150.948,
    transform: "rotate(-60 -35.7856 217.023)",
    fill: "white",
    fillOpacity: 0.51
  }), /*#__PURE__*/React.createElement("rect", {
    x: -35.7856,
    y: 217.023,
    width: 301.896,
    height: 301.896,
    rx: 150.948,
    transform: "rotate(-60 -35.7856 217.023)",
    stroke: "#0D408D",
    strokeWidth: 0.504
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bddi_5930_3158)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.2744,
    y: 93.136,
    width: 32.2579,
    height: 32.2579,
    rx: 16.128,
    transform: "rotate(-60 19.2744 93.136)",
    fill: "white",
    fillOpacity: 0.4,
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 11.0054,
    y: 147.826,
    width: 226.296,
    height: 226.296,
    rx: 113.148,
    transform: "rotate(-40 11.0054 147.826)",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.0054,
    y: 147.826,
    width: 226.296,
    height: 226.296,
    rx: 113.148,
    transform: "rotate(-40 11.0054 147.826)",
    stroke: "#0D408D",
    strokeWidth: 0.504
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_bddi_5930_3158)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_5930_3158)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 128.736,
    y: 43.6971,
    width: 32.2577,
    height: 32.2577,
    rx: 16.128,
    transform: "rotate(-40 128.736 43.6971)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.736,
    y: 43.6971,
    width: 32.2577,
    height: 32.2577,
    rx: 16.128,
    transform: "rotate(-40 128.736 43.6971)",
    fill: "#FF5D30",
    fillOpacity: 0.4
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 64.2632,
    y: 152.488,
    width: 150.696,
    height: 150.696,
    rx: 75.348,
    transform: "rotate(-40 64.2632 152.488)",
    fill: "white",
    fillOpacity: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.2632,
    y: 152.488,
    width: 150.696,
    height: 150.696,
    rx: 75.348,
    transform: "rotate(-40 64.2632 152.488)",
    stroke: "#0D408D",
    strokeWidth: 0.504
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_bddi_5930_3158)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 181.654,
    y: 93.593,
    width: 32.2577,
    height: 32.2577,
    rx: 16.128,
    transform: "rotate(-40 181.654 93.593)",
    fill: "#FF5539"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.009,
    y: 93.6241,
    width: 31.7537,
    height: 31.7537,
    rx: 15.876,
    transform: "rotate(-40 182.009 93.6241)",
    stroke: "#0D408D",
    strokeWidth: 0.504
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.28053,
    y: 0.752824,
    width: 269.438,
    height: 150.494,
    rx: 8.1144,
    stroke: "#ECE6FF",
    strokeWidth: 0.7056
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bddi_5930_3158",
    x: 16.7544,
    y: 62.6798,
    width: 49.1054,
    height: 49.1051,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.26
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_5930_3158"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.504,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect2_dropShadow_5930_3158"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_5930_3158",
    result: "effect2_dropShadow_5930_3158"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.008,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect3_dropShadow_5930_3158"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_5930_3158",
    result: "effect3_dropShadow_5930_3158"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_5930_3158",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.252
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect4_innerShadow_5930_3158"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_bddi_5930_3158",
    x: 126.216,
    y: 20.4423,
    width: 50.4853,
    height: 50.4857,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.26
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_5930_3158"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.504,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect2_dropShadow_5930_3158"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_5930_3158",
    result: "effect2_dropShadow_5930_3158"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.008,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect3_dropShadow_5930_3158"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_5930_3158",
    result: "effect3_dropShadow_5930_3158"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_5930_3158",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.252
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect4_innerShadow_5930_3158"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_bddi_5930_3158",
    x: 179.134,
    y: 70.3382,
    width: 50.4853,
    height: 50.4857,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.26
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_5930_3158"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.504,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect2_dropShadow_5930_3158"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_5930_3158",
    result: "effect2_dropShadow_5930_3158"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.008,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect3_dropShadow_5930_3158"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_5930_3158",
    result: "effect3_dropShadow_5930_3158"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_5930_3158",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.252
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect4_innerShadow_5930_3158"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5930_3158",
    x1: 136,
    y1: 0.400024,
    x2: 136,
    y2: 151.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0EDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5930_3158",
    x1: 136,
    y1: 0.400024,
    x2: 136,
    y2: 151.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5930_3158"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.927734,
    y: 0.400024,
    width: 270.144,
    height: 151.2,
    rx: 8.4672,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_5930_3158"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 128.736,
    y: 43.6971,
    width: 32.2577,
    height: 32.2577,
    rx: 16.128,
    transform: "rotate(-40 128.736 43.6971)",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolutionMobile);
export default __webpack_public_path__ + "static/media/solution-mobile.96111cbd30751414a8808359eeb11cea.svg";
export { ForwardRef as ReactComponent };